export const QUERY_PAYMENT = {
    ORDER_TOKEN: 'orderToken',
    REGION: 'region',
    CURRENCY: 'currency',
    ERROR: 'error',
    PP_TRANSACTION_ID: 'ppTransactionId',
    DEFAULT_PAYMENT_METHOD: 'defaultPaymentMethod',
    DOUBLE_OPT_IN: 'doubleOptIn',
    CART_TOKEN: 'c_t',
} as const;
